import { type InventoryCategory } from '@/types/InventoryCategory';
import { useQuery } from '@tanstack/vue-query';

export function useMoveInventoryCategories() {
    const {
        data: inventoryCategories,
        isLoading,
        isFetching,
        isFetched,
        refetch,
        error,
    } = useQuery({
        queryKey: ['inventory-categories'],
        queryFn: getInventoryCategories,
        retry: false,
        staleTime: 1000 * 60 * 60 * 24, // 24 hours
    });

    async function getInventoryCategories() {
        const response = await window.axios.get('/customers/book/inventory-categories?type=MOVE');
        console.log(response);
        return response.data.data as InventoryCategory[];
    }

    function getInventoryCategory(inventoryCategoryId: number) {
        return inventoryCategories.value?.find((category) => category.id === inventoryCategoryId);
    }

    return {
        inventoryCategories,
        isLoading,
        isFetching,
        isFetched,
        refetch,
        error,
        getInventoryCategory,
    };
}
